import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';

import { appRouteProviders } from './app.routes';
import { DataProvider } from './providers/data.provider';
import { LinkService } from './providers/link.provider';
import { SeoProvider } from './providers/seo.provider';

export const appConfig: ApplicationConfig = {
	providers: [...appRouteProviders, provideClientHydration(), DataProvider, LinkService, SeoProvider, provideHttpClient(withInterceptorsFromDi(), withFetch())]
};
